<template>
    <div v-if="showResult" class="potential-earnings">
        <div class="potential-earnings__title">
            {{ $t('dynamicess.simulation.title') }}
        </div>
        <div class="potential-earnings__value-container">
            <span class="potential-earnings__value">{{ currency.sign }}{{ earnings }}</span>
            <span class="potential-earnings__time-simulated">
                {{ $t('dynamicess.simulation.duration', { months: monthsSimulated }) }}
            </span>
        </div>
        <div v-if="earningsPercentage !== null" class="potential-earnings__percentage">
            ↑ {{ earningsPercentage }}%
        </div>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import { DYNAMIC_ESS } from '@/vue/store/modules/dynamic-ess-form';

@Component
@AngularDirective('potential-earnings')
export default class PotentialEarnings extends Vue {
    @ngInject()
    ApiService;
    @ngInject()
    InstallationsService;

    simulating = false;
    simulationFailed = false;
    simulationResult = null;

    mounted() {
        this.simulate();
    }

    simulate() {
        if (this.simulating) return;

        this.simulating = true;
        this.simulationFailed = false;
        this.simulationResult = null;

        this.ApiService.simulateHistoricEss(this.idSite, this.configuration)
            .then(response => {
                if (response.status !== 200 || !response.data || !response.data.success) {
                    this.simulationFailed = true;
                    return;
                }
                this.simulationResult = response.data.result;
            })
            .catch(() => (this.simulationFailed = true))
            .finally(() => (this.simulating = false));
    }

    get showResult() {
        return !this.simulating && !this.simulationFailed && this.earnings > 0;
    }

    get earnings() {
        if (this.simulationResult === null) return null;
        const defaultEarnings = this.simulationResult.costs.default.earnings;
        const dynamicEarnings = this.simulationResult.costs.dynamic.earnings;
        const earnings = dynamicEarnings - defaultEarnings;
        return Math.round(earnings);
    }

    get earningsPercentage() {
        if (this.simulationResult === null) return null;
        const defaultEarnings = this.simulationResult.costs.default.earnings;
        const dynamicEarnings = this.simulationResult.costs.dynamic.earnings;
        if (defaultEarnings === 0) return null; // avoid division by zero
        const fraction = -(dynamicEarnings / defaultEarnings - 1);
        return Math.round(fraction * 100);
    }

    get monthsSimulated() {
        if (this.simulationResult === null) return null;
        const daysSimulated = this.simulationResult.daysSimulated;
        return Math.round(daysSimulated / 30);
    }

    get idSite() {
        return this.$route.params.id;
    }

    get configuration() {
        const isValid = this.$store.getters[DYNAMIC_ESS.FORM_VALID];
        return isValid ? this.$store.getters[DYNAMIC_ESS.TO_API_DTO] : null;
    }

    get currency() {
        return this.InstallationsService.activeInstallation.currency;
    }
}
</script>
